import { render, staticRenderFns } from "./ShopInfo.vue?vue&type=template&id=5e2ad5cf&scoped=true"
import script from "./ShopInfo.vue?vue&type=script&lang=js"
export * from "./ShopInfo.vue?vue&type=script&lang=js"
import style0 from "./ShopInfo.vue?vue&type=style&index=0&id=5e2ad5cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2ad5cf",
  null
  
)

export default component.exports